.container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
    justify-content: center;
}

.btn {
    display: inline-block;
    border: none;
    padding: 5px 20px;
    border-radius: 25px;
    box-shadow: 0 1px 3px 0.2px rgba(0, 0, 0, 0.3);
    text-align: center;
    vertical-align: middle;
    line-height: 1.5;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
        border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    &:hover {
        filter: brightness(1.1);
        box-shadow: 0 1px 2px 0px rgba(0, 0, 0, 0.3);
    }

    &:active {
        filter: brightness(0.9);
        box-shadow: 0 1px 2px 0px rgba(0, 0, 0, 0.3);
    }
}

.btnSuccess {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745;
}

.btnDanger {
    color: #fff;
    background-color: #dc3545;
}

.btnSecondary {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d;
}
